import { Component } from 'react'
import { Code, CodeableConcepts, Participant, ContactPoints, Period } from '../helpers'
import { FaPeopleGroup } from 'react-icons/fa6'

import './resource.css'

class CareTeam extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><FaPeopleGroup /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.category && 'Classification'}</div>
                            <div className='Res-Title'>{this.props.resource.category && CodeableConcepts(this.props.resource.category)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.name && 'Name'}</div>
                        <div className='Res-Title'>{this.props.resource.name && this.props.resource.name}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.period && 'Period'}</div>
                        <div className='Res-Title'>{this.props.resource.period && Period(this.props.resource.period)}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.participant && 'Participant'}</div>
                        <div className='Res-Title'>{this.props.resource.participant && Participant(this.props.resource.participant)}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.reasonCode && 'Reason'}</div>
                        <div className='Res-Title'>{this.props.resource.reasonCode && CodeableConcepts(this.props.resource.reasonCode)}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.telecom && 'Contact'}</div>
                        <div className='Res-Title'>{this.props.resource.telecom && ContactPoints(this.props.resource.telecom)}</div>
                    </div>
                </div>
            }
        </div></div>
    }
}

export default CareTeam